import React from "react";
import { Box, Typography, CircularProgress, Stack } from "@mui/material";

import ReactJson from "react-json-view";

import { formatDate } from "../../../../utils/format";
import {
  DetailDrawer,
  Section,
  TOKENS,
} from "../../../../components/pages/_new/super/design";

const KV = ({ k, v, mono }) => (
  <Stack direction="row" spacing={2} sx={{ py: 0.5, alignItems: "flex-start" }}>
    <Typography sx={{ fontSize: 12.5, color: TOKENS.fg3, minWidth: 120 }}>{k}</Typography>
    <Typography
      sx={{
        fontSize: 13,
        color: TOKENS.fg1,
        wordBreak: "break-all",
        fontFamily: mono
          ? "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace"
          : undefined,
      }}
    >
      {v ?? "—"}
    </Typography>
  </Stack>
);

function ViewLog({ open, handleClose, log, loading }) {
  return (
    <DetailDrawer
      open={open}
      onClose={handleClose}
      title="Audit Log Detail"
      subtitle={log?.action || ""}
    >
      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
          <CircularProgress size={24} />
        </Box>
      ) : (
        <Box>
          <Section label="Account">
            <KV k="Email" v={log?.user?.email} mono />
            <KV k="Username" v={log?.user?.username} />
          </Section>
          {log?.organisation && 0 < Object.keys(log?.organisation || {}).length ? (
            <Section label="Organisation">
              <KV k="ID" v={log?.organisation?.id} mono />
              <KV k="Title" v={log?.organisation?.title} />
              <KV k="Administrator" v={log?.organisation?.administrator?.username} />
            </Section>
          ) : null}
          <Section label="Event">
            <KV k="Time" v={log?.date ? formatDate(log.date) : "—"} />
            <KV k="Client IP" v={log?.ip_addr} mono />
            <KV k="Action" v={log?.action} />
            <KV k="URL" v={log?.url} mono />
            {log?.site_id ? <KV k="Site" v={log?.site_id} mono /> : null}
          </Section>
          <Section label="Parameters">
            <Box
              sx={{
                border: `1px solid ${TOKENS.borderSubtle}`,
                borderRadius: `${TOKENS.radiusXs}px`,
                p: 1.5,
                background: TOKENS.bgSunken,
              }}
            >
              <ReactJson
                name="params"
                src={log?.params || {}}
                displayDataTypes={false}
                style={{ wordBreak: "break-word", background: "transparent" }}
              />
            </Box>
          </Section>
        </Box>
      )}
    </DetailDrawer>
  );
}

export default ViewLog;
